const cnpj = '42.571.167/0001-52';
const susepNumber = '212122340';

export default {
  brokerDisclaimer: `A Luna Seguros LTDA, mais conhecida como Luna, é uma corretora de seguros digital, nosso CNPJ é o ${cnpj} e estamos registrados na SUSEP com o número ${susepNumber}. Nosso escritório fica na Alameda Santos, 1827, Conjunto 112, Jardim Paulista São Paulo – SP 01419-002.`,
  cnpj,
  susepNumber,
};
